// TEMPORARY:
// Publish Preview is disabled unless explicitly enabled while prediction accuracy
// is being corrected. Keep the underlying implementation intact so the feature
// can be restored after validation.
export const PUBLISH_PREVIEW_ENABLED =
  String(import.meta.env.VITE_PUBLISH_PREVIEW_ENABLED ?? 'false').toLowerCase() === 'true'
